<template>
  <div id="footer-content" style="z-index: 999999999 !important;">
    <footer class="mt-auto">
      <div class="container-fluid ">
        <div class="row">
          <div class="col-md-5 col-12"></div>
          <div class="col-md-2 col-12 py-2 mb-0 bg-gob">
              <div class="d-block text-center ">
                <small style="font-size:.6rem" class="m-0 p-0 d-block"><b><i class="fa-regular fa-copyright"></i> Todos los derechos reservados.</b></small>
                <p style="font-size:.78rem" class="m-0 p-0"><b>Gobierno del Estado de Chiapas</b></p>
              </div>
          </div>
          <div
            style="font-size:.78rem; cursor:pointer"
            class="col-md-5 col-12 aviso justify-content-center justify-content-md-end">
            <div class="btn btn-secondary"  @click="verModal = true">Aviso de privacidad</div>
              
            </div>
        </div>
        <!-- <div class="d-flex align-items-center py-2 mb-0 justify-content-center small text-white">
          <div class="d-block text-center">
            <small class="m-0 p-0 d-block"><i class="fa-regular fa-copyright"></i> Todos los derechos reservados.</small>
            <p style="font-size:.78rem" class="m-0 p-0">Gobierno del Estado de Chiapas</p>
           </div>
          <div class="d-none">
          </div>
        </div> -->
      </div>
    </footer>

    <div class="aviso_">
      <px-modal 
          v-show="verModal" 
          @verModal="verModal = $event" 
          idModal="ModalAviso" 
          textHeader="Avíso de Privacidad"
          modalWidth="900px"
      >
          <p class="border-bottom pb-4 m-0">
            La Subsecretaría de Egresos de la Secretaría de Finanzas, es responsable del tratamiento de los datos personales que nos proporcione; mismos que serán protegidos conforme a lo dispuesto por la Ley de Protección de Datos Personales en Posesión de Sujetos Obligados del Estado de Chiapas. Los datos personales recabados en el Sistema Integral de Gestión Hacendaria y Administrativa de Chiapas(SIGHA), versión Organismo Público es responsabilidad de cada Ente Público a través del Administrador del SIGHA, mismo que debe ser utilizado únicamente para la creación de las cuentas de los Usuarios Operativos (nombre, área de adscripción) y para la generación de documentos Oficiales a través del Sistema en mención. Se le informa que no se realizarán transferencias de sus datos personales. Para mayor información acerca del tratamiento, así como para el acceso, rectificación, cancelación y oposición en materia de datos personales, se pone a su disposición el aviso de privacidad integral para su consulta en internet en la dirección electrónica siguiente: <a target="_blank" href="http://www.haciendachiapas.gob.mx/SitioNuevo/aviso-de-privacidad"> http://www.haciendachiapas.gob.mx/SitioNuevo/aviso-de-privacidad </a>            
          </p>
          <div class="d-flex justify-content-end pt-2">
              <vs-button class="btn-primary-o px-5" @click="verModal=false">Cerrar</vs-button>
          </div>
      </px-modal>
    </div>

  </div>
</template>

<script>
import PxModal from '@/components/PxModal.vue'
export default ({
  components: { PxModal },
  data: function(){
        return{
            verModal: false
        }
    }
})
</script>


<style scoped>
.bg-gob{
background: linear-gradient(rgba(255,255,255,.70),rgba(255,255,255,.80)) !important;
}
.aviso {
  font-size: 0.75rem;
  cursor: pointer;
  color: #94a1ad;
  display: flex;
  align-items: center;
}

#footer-content {    
  background-color:#fff;
  background: url('../../assets/img/cinta.svg');
  background-repeat: repeat-x;
  background-size: auto 50px;
}
</style>